import React from "react"
import { join } from "path"
import Link from "~components/link/link"
import * as styles from "./pagination.module.css"

const PAGINATION_THRESHOLD = 5

const Pagination = ({ currentPage, numPages, path }) => {
  if (numPages <= 1) {
    return null
  }

  const basePath = path.replace(/(\/p\d+\/?)$/, `/`)

  const exceptFirstPage = (page) => (page === 1 ? basePath : `${join(basePath, `p${page}`)}/`)

  currentPage = parseInt(currentPage)
  const startPage = Math.max(currentPage - PAGINATION_THRESHOLD, 1)
  const endPage = Math.min(currentPage + PAGINATION_THRESHOLD, numPages)

  return (
    <div className={styles.pagination}>
      {currentPage !== 1 && (
        <Link key={`prev`} to={exceptFirstPage(currentPage - 1)}>
          « Previous
        </Link>
      )}
      {[...Array(endPage - startPage + 1)].map((_, i) => {
        const page = i + 1
        return page === currentPage ? (
          <span key={`p${page}`}>{currentPage}</span>
        ) : (
          <Link key={`p${page}`} to={exceptFirstPage(page)}>
            {page}
          </Link>
        )
      })}
      {currentPage !== numPages && (
        <Link key={`next`} to={exceptFirstPage(currentPage + 1)}>
          Next »
        </Link>
      )}
    </div>
  )
}

export default Pagination
